import { ComponentPropsWithoutRef, ComponentType } from 'react';
import './empty-container.scss';

type Props = ComponentPropsWithoutRef<'div'> & {
    icon: ComponentType<ComponentPropsWithoutRef<'svg'>>;
    text: string;
};
export const EmptyContainer = ({ icon: Icon, text, ...props }: Props) => (
    <div className="empty-container" {...props}>
        <Icon />
        <p>{text}</p>
    </div>
);
